import React from 'react';
import CountUp from 'react-countup';
import { usePrefersReducedMotion } from '../../hooks/usePrefersReducedMotion';

export type AnimatedValueProps = {
  value: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  duration?: number;
  className?: string;
  enableScrollSpy?: boolean;
};

const easeOutExpo = (t: number, b: number, c: number, d: number) =>
  c * (-Math.pow(2, (-10 * t) / d) + 1) + b;

export function AnimatedNumber({
  value,
  prefix = '',
  suffix = '',
  decimals,
  duration = 1.2,
  className,
  enableScrollSpy = false,
}: AnimatedValueProps) {
  const reduced = usePrefersReducedMotion();
  const resolvedDecimals =
    decimals ?? (Math.abs(value % 1) > 1e-9 ? 2 : 0);

  if (reduced) {
    const formatted = value.toLocaleString('fr-FR', {
      minimumFractionDigits: resolvedDecimals,
      maximumFractionDigits: resolvedDecimals,
    });
    return (
      <span className={className}>
        {prefix}
        {formatted}
        {suffix}
      </span>
    );
  }

  return (
    <CountUp
      end={value}
      duration={duration}
      separator=" "
      decimal=","
      decimals={resolvedDecimals}
      prefix={prefix}
      suffix={suffix}
      useEasing
      easingFn={easeOutExpo}
      enableScrollSpy={enableScrollSpy}
      scrollSpyOnce={enableScrollSpy}
      className={className}
    />
  );
}
